import CustomTooltip from "./CustomTooltip";

const ToggleButton = ({ disassemblyRequiredBookingItem, itemIndex, item }) => {


  return (
    <div className="absolute right-0 top-1/2 transform -translate-y-1/2 cursor-pointer">
      <CustomTooltip text="Want to disassemble?">

        <div

          className={`w-[28px] h-[16px] rounded-[15px] flex items-center px-[2px] transition-all duration-200 ${!item.isDisassembleRequired
              ? "bg-[#CDCCD7] justify-start"
              : "bg-[#34318C] justify-end"
            }`}
          style={item.isDisassemble ? {} : { display: "none" }}
          onClick={() => disassemblyRequiredBookingItem(itemIndex)}
        >
          <div
            className={`transition-all duration-200 ${item.disassemblyRequired
                ? "w-[12px] h-[12px] rounded-full bg-[#FFFFFF]"
                : "w-[12px] h-[12px] rounded-full bg-[#FFFFFF]"
              }`}
          ></div>
        </div>
      </CustomTooltip>
    </div>
  );
};

export default ToggleButton;
